export async function getDeviceInfo(): Promise<MediaDeviceInfo[]> {
  return await navigator.mediaDevices.enumerateDevices()
}
// Fonction pour trouver un device par son label
export const getDeviceId = (devices: MediaDeviceInfo[], label: string) => {
  return devices.find((device: MediaDeviceInfo) => device.label.includes(label))
}

// Fonction pour attendre qu'un device soit disponible
export const awaitingDevice = async (
  label: string,
  onWaiting: () => void,
): Promise<MediaDeviceInfo | undefined> => {
  const device = await getDeviceInfo().then((devices) => {
    return getDeviceId(devices, label)
  })

  if (device) {
    return device
  } else {
    // Le device n'est pas encore dans la liste, on attend
    onWaiting()
    return await new Promise((resolve) => {
      navigator.mediaDevices.addEventListener(
        "devicechange",
        () => resolve(awaitingDevice(label, onWaiting)),
        { once: true },
      )
    })
  }
}
